/**
 * Resource map data: major, well-documented resource sites, crop regions and ports in
 * coastal West Africa. Coordinates are APPROXIMATE (good to a few kilometres) and are shown
 * as such on the page. Rivers, lakes, roads and rail come from the map tiles (OpenStreetMap).
 * Edit here to add sites: { id, name, area, country, kind, category, element, symbol, lat, lng, note, sources }
 */

export const COUNTRIES = [['CV', 'Cabo Verde'], ['SN', 'Senegal'], ['GM', 'The Gambia'], ['GW', 'Guinea-Bissau'], ['GN', 'Guinea'], ['SL', 'Sierra Leone'], ['LR', 'Liberia'], ['CI', "Côte d'Ivoire"], ['GH', 'Ghana'], ['TG', 'Togo'], ['BJ', 'Benin'], ['NG', 'Nigeria'], ['ML', 'Mali'], ['BF', 'Burkina Faso']];
export const CATEGORIES = [['minerals', 'Minerals & metals'], ['energy', 'Oil, gas & coal'], ['agriculture', 'Crops'], ['construction', 'Construction materials']];

/** Chemical elements shown on the map: symbol -> name */
export const ELEMENTS = {
  Au: 'Gold',
  Fe: 'Iron ore',
  Al: 'Bauxite (aluminium)',
  Mn: 'Manganese',
  Li: 'Lithium',
  Sn: 'Tin',
  C: 'Diamonds (carbon)',
  P: 'Phosphate'
};
export const CROPS = ['Cocoa', 'Cashew', 'Cotton', 'Groundnuts', 'Rubber', 'Palm oil', 'Shea'];
const USGS = {
  name: 'USGS Minerals Yearbook (Africa)',
  url: 'https://www.usgs.gov/centers/national-minerals-information-center/africa-and-middle-east'
};
const FAO = {
  name: 'FAOSTAT (FAO crop statistics)',
  url: 'https://www.fao.org/faostat/'
};
const EIA = {
  name: 'U.S. EIA country analyses',
  url: 'https://www.eia.gov/international/overview/world'
};
export const SITES = [
// ---- Gold (Au)
{
  id: 'obuasi',
  name: 'Obuasi',
  area: 'Ashanti Region',
  country: 'GH',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 6.2,
  lng: -1.67,
  note: 'One of the oldest and deepest gold mines in West Africa.',
  sources: [USGS]
}, {
  id: 'tarkwa',
  name: 'Tarkwa',
  area: 'Western Region',
  country: 'GH',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 5.3,
  lng: -1.99,
  note: 'A centre of large-scale gold mining in western Ghana.',
  sources: [USGS]
}, {
  id: 'siguiri',
  name: 'Siguiri',
  area: 'Kankan Region',
  country: 'GN',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 11.42,
  lng: -9.17,
  note: 'A major gold-mining area in north-eastern Guinea.',
  sources: [USGS]
}, {
  id: 'loulo',
  name: 'Loulo-Gounkoto',
  area: 'Kayes Region',
  country: 'ML',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 12.95,
  lng: -11.4,
  note: 'A large gold mining complex in western Mali.',
  sources: [USGS]
}, {
  id: 'sadiola',
  name: 'Sadiola',
  area: 'Kayes Region',
  country: 'ML',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 13.9,
  lng: -11.7,
  note: 'A gold mine in western Mali.',
  sources: [USGS]
}, {
  id: 'sabodala',
  name: 'Sabodala',
  area: 'Kédougou Region',
  country: 'SN',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 13.18,
  lng: -12.12,
  note: "Senegal's main gold-mining area.",
  sources: [USGS]
}, {
  id: 'ity',
  name: 'Ity',
  area: 'Montagnes District',
  country: 'CI',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 6.87,
  lng: -8.1,
  note: "A gold mine in western Côte d'Ivoire.",
  sources: [USGS]
}, {
  id: 'segilola',
  name: 'Segilola',
  area: 'Osun State',
  country: 'NG',
  kind: 'resource',
  category: 'minerals',
  element: 'Au',
  resource: 'Gold',
  lat: 7.63,
  lng: 4.53,
  note: "Nigeria's first commercial-scale gold mine.",
  sources: [USGS]
},
// ---- Iron ore (Fe)
{
  id: 'simandou',
  name: 'Simandou',
  area: 'Nzérékoré / Kankan',
  country: 'GN',
  kind: 'resource',
  category: 'minerals',
  element: 'Fe',
  resource: 'Iron ore',
  lat: 8.6,
  lng: -8.9,
  note: 'One of the world’s largest undeveloped high-grade iron ore deposits.',
  sources: [USGS]
}, {
  id: 'nimba',
  name: 'Yekepa (Nimba)',
  area: 'Nimba County',
  country: 'LR',
  kind: 'resource',
  category: 'minerals',
  element: 'Fe',
  resource: 'Iron ore',
  lat: 7.58,
  lng: -8.53,
  note: 'Iron ore mining linked by rail to the port of Buchanan.',
  sources: [USGS]
}, {
  id: 'tonkolili',
  name: 'Tonkolili',
  area: 'Northern Province',
  country: 'SL',
  kind: 'resource',
  category: 'minerals',
  element: 'Fe',
  resource: 'Iron ore',
  lat: 9.0,
  lng: -11.6,
  note: 'An iron ore deposit in central Sierra Leone.',
  sources: [USGS]
}, {
  id: 'itakpe',
  name: 'Itakpe',
  area: 'Kogi State',
  country: 'NG',
  kind: 'resource',
  category: 'minerals',
  element: 'Fe',
  resource: 'Iron ore',
  lat: 7.6,
  lng: 6.3,
  note: "Supplies iron ore to the Ajaokuta steel complex.",
  sources: [USGS]
},
// ---- Bauxite (Al)
{
  id: 'sangaredi',
  name: 'Sangarédi (Boké)',
  area: 'Boké Region',
  country: 'GN',
  kind: 'resource',
  category: 'minerals',
  element: 'Al',
  resource: 'Bauxite',
  lat: 11.1,
  lng: -13.8,
  note: 'Part of the Boké bauxite region, among the world’s largest sources of bauxite.',
  sources: [USGS]
}, {
  id: 'awaso',
  name: 'Awaso',
  area: 'Western North Region',
  country: 'GH',
  kind: 'resource',
  category: 'minerals',
  element: 'Al',
  resource: 'Bauxite',
  lat: 6.23,
  lng: -2.27,
  note: 'A bauxite mine in western Ghana.',
  sources: [USGS]
},
// ---- Manganese, lithium, tin, diamonds, phosphate
{
  id: 'nsuta',
  name: 'Nsuta',
  area: 'Western Region',
  country: 'GH',
  kind: 'resource',
  category: 'minerals',
  element: 'Mn',
  resource: 'Manganese',
  lat: 5.28,
  lng: -1.96,
  note: 'A long-running manganese mine near Tarkwa.',
  sources: [USGS]
}, {
  id: 'ewoyaa',
  name: 'Ewoyaa',
  area: 'Central Region',
  country: 'GH',
  kind: 'resource',
  category: 'minerals',
  element: 'Li',
  resource: 'Lithium',
  lat: 5.27,
  lng: -1.02,
  note: "Ghana's first lithium project, near Mankessim.",
  sources: [USGS]
}, {
  id: 'jos',
  name: 'Jos Plateau',
  area: 'Plateau State',
  country: 'NG',
  kind: 'resource',
  category: 'minerals',
  element: 'Sn',
  resource: 'Tin',
  lat: 9.9,
  lng: 8.9,
  note: 'Historic tin and columbite mining area.',
  sources: [USGS]
}, {
  id: 'kono',
  name: 'Kono (Koidu)',
  area: 'Eastern Province',
  country: 'SL',
  kind: 'resource',
  category: 'minerals',
  element: 'C',
  resource: 'Diamonds',
  lat: 8.64,
  lng: -10.97,
  note: "Sierra Leone's main diamond-producing district.",
  sources: [USGS]
}, {
  id: 'hahotoe',
  name: 'Hahotoé-Kpogamé',
  area: 'Maritime Region',
  country: 'TG',
  kind: 'resource',
  category: 'minerals',
  element: 'P',
  resource: 'Phosphate',
  lat: 6.35,
  lng: 1.42,
  note: "Togo's main phosphate mining area.",
  sources: [USGS]
}, {
  id: 'taiba',
  name: 'Taïba',
  area: 'Thiès Region',
  country: 'SN',
  kind: 'resource',
  category: 'minerals',
  element: 'P',
  resource: 'Phosphate',
  lat: 14.9,
  lng: -16.9,
  note: 'Phosphate mining north-east of Dakar.',
  sources: [USGS]
},
// ---- Energy
{
  id: 'nigerdelta',
  name: 'Niger Delta',
  area: 'Rivers, Bayelsa, Delta',
  country: 'NG',
  kind: 'resource',
  category: 'energy',
  element: null,
  symbol: 'Oil',
  resource: 'Oil & gas',
  lat: 5.0,
  lng: 6.5,
  note: "The centre of Nigeria's oil and gas production.",
  sources: [EIA]
}, {
  id: 'jubilee',
  name: 'Jubilee field',
  area: 'Offshore Western Region',
  country: 'GH',
  kind: 'resource',
  category: 'energy',
  element: null,
  symbol: 'Oil',
  resource: 'Oil & gas',
  lat: 4.6,
  lng: -2.9,
  note: "Ghana's main offshore oil field.",
  sources: [EIA]
}, {
  id: 'sangomar',
  name: 'Sangomar field',
  area: 'Offshore',
  country: 'SN',
  kind: 'resource',
  category: 'energy',
  element: null,
  symbol: 'Oil',
  resource: 'Oil & gas',
  lat: 13.3,
  lng: -17.8,
  note: "Senegal's first offshore oil field.",
  sources: [EIA]
}, {
  id: 'enugu',
  name: 'Enugu',
  area: 'Enugu State',
  country: 'NG',
  kind: 'resource',
  category: 'energy',
  element: null,
  symbol: 'Coal',
  resource: 'Coal',
  lat: 6.45,
  lng: 7.5,
  note: 'Historic coal-mining area ("Coal City").',
  sources: [USGS]
},
// ---- Construction
{
  id: 'obajana',
  name: 'Obajana',
  area: 'Kogi State',
  country: 'NG',
  kind: 'resource',
  category: 'construction',
  element: null,
  symbol: 'Ls',
  resource: 'Limestone',
  lat: 7.93,
  lng: 6.43,
  note: 'Limestone quarrying for one of Africa’s largest cement plants.',
  sources: [USGS]
},
// ---- Crops
{
  id: 'cocoa-ci',
  name: 'Soubré cocoa belt',
  area: 'Nawa Region',
  country: 'CI',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cocoa',
  resource: 'Cocoa',
  lat: 5.79,
  lng: -6.6,
  note: "Côte d'Ivoire is the world's largest cocoa producer.",
  sources: [FAO]
}, {
  id: 'cocoa-gh',
  name: 'Western Ghana cocoa belt',
  area: 'Western North Region',
  country: 'GH',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cocoa',
  resource: 'Cocoa',
  lat: 6.4,
  lng: -2.3,
  note: 'Part of the world’s second-largest cocoa-producing country.',
  sources: [FAO]
}, {
  id: 'cocoa-ng',
  name: 'Ondo cocoa belt',
  area: 'Ondo State',
  country: 'NG',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cocoa',
  resource: 'Cocoa',
  lat: 7.1,
  lng: 4.84,
  note: "Nigeria's leading cocoa-producing state.",
  sources: [FAO]
}, {
  id: 'cashew-ci',
  name: 'Northern cashew zone',
  area: 'Korhogo',
  country: 'CI',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cashew',
  resource: 'Cashew',
  lat: 9.45,
  lng: -5.63,
  note: 'A major raw cashew-producing area.',
  sources: [FAO]
}, {
  id: 'cashew-gw',
  name: 'Guinea-Bissau cashew',
  area: 'Cacheu / Oio',
  country: 'GW',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cashew',
  resource: 'Cashew',
  lat: 12.15,
  lng: -15.4,
  note: "Cashew is Guinea-Bissau's main export.",
  sources: [FAO]
}, {
  id: 'groundnut-sn',
  name: 'Groundnut basin',
  area: 'Kaolack',
  country: 'SN',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Groundnuts',
  resource: 'Groundnuts',
  lat: 14.15,
  lng: -16.07,
  note: "The heart of Senegal's groundnut production.",
  sources: [FAO]
}, {
  id: 'cotton-ml',
  name: 'Sikasso cotton zone',
  area: 'Sikasso Region',
  country: 'ML',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cotton',
  resource: 'Cotton',
  lat: 11.32,
  lng: -5.67,
  note: "Mali's main cotton-growing region.",
  sources: [FAO]
}, {
  id: 'cotton-bf',
  name: 'Western cotton zone',
  area: 'Hauts-Bassins',
  country: 'BF',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Cotton',
  resource: 'Cotton',
  lat: 11.18,
  lng: -4.3,
  note: 'A major cotton-growing area of Burkina Faso.',
  sources: [FAO]
}, {
  id: 'rubber-lr',
  name: 'Harbel rubber plantation',
  area: 'Margibi County',
  country: 'LR',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Rubber',
  resource: 'Rubber',
  lat: 6.27,
  lng: -10.35,
  note: 'One of the largest rubber plantations in the world.',
  sources: [FAO]
}, {
  id: 'palm-ng',
  name: 'South-east oil palm belt',
  area: 'Imo, Abia, Akwa Ibom',
  country: 'NG',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Palm oil',
  resource: 'Palm oil',
  lat: 5.3,
  lng: 7.6,
  note: 'A traditional palm-oil producing region.',
  sources: [FAO]
}, {
  id: 'shea-gh',
  name: 'Northern shea belt',
  area: 'Northern Region',
  country: 'GH',
  kind: 'crop',
  category: 'agriculture',
  crop: 'Shea',
  resource: 'Shea',
  lat: 9.4,
  lng: -0.84,
  note: 'Shea nuts are gathered across the northern savannah.',
  sources: [FAO]
}];
export const PORTS = [{
  id: 'dakar',
  name: 'Dakar',
  country: 'SN',
  lat: 14.68,
  lng: -17.43
}, {
  id: 'banjul',
  name: 'Banjul',
  country: 'GM',
  lat: 13.45,
  lng: -16.58
}, {
  id: 'bissau',
  name: 'Bissau',
  country: 'GW',
  lat: 11.86,
  lng: -15.6
}, {
  id: 'conakry',
  name: 'Conakry',
  country: 'GN',
  lat: 9.51,
  lng: -13.71
}, {
  id: 'kamsar',
  name: 'Kamsar',
  country: 'GN',
  lat: 10.65,
  lng: -14.6
}, {
  id: 'freetown',
  name: 'Freetown',
  country: 'SL',
  lat: 8.49,
  lng: -13.23
}, {
  id: 'monrovia',
  name: 'Monrovia',
  country: 'LR',
  lat: 6.35,
  lng: -10.79
}, {
  id: 'buchanan',
  name: 'Buchanan',
  country: 'LR',
  lat: 5.88,
  lng: -10.05
}, {
  id: 'sanpedro',
  name: 'San-Pédro',
  country: 'CI',
  lat: 4.74,
  lng: -6.62
}, {
  id: 'abidjan',
  name: 'Abidjan',
  country: 'CI',
  lat: 5.27,
  lng: -4.02
}, {
  id: 'takoradi',
  name: 'Takoradi',
  country: 'GH',
  lat: 4.89,
  lng: -1.75
}, {
  id: 'tema',
  name: 'Tema',
  country: 'GH',
  lat: 5.63,
  lng: 0.01
}, {
  id: 'lome',
  name: 'Lomé',
  country: 'TG',
  lat: 6.13,
  lng: 1.28
}, {
  id: 'cotonou',
  name: 'Cotonou',
  country: 'BJ',
  lat: 6.35,
  lng: 2.43
}, {
  id: 'lagos',
  name: 'Lagos (Apapa)',
  country: 'NG',
  lat: 6.44,
  lng: 3.37
}, {
  id: 'lekki',
  name: 'Lekki Deep Sea Port',
  country: 'NG',
  lat: 6.43,
  lng: 4.0
}, {
  id: 'onne',
  name: 'Onne',
  country: 'NG',
  lat: 4.71,
  lng: 7.15
}, {
  id: 'calabar',
  name: 'Calabar',
  country: 'NG',
  lat: 4.96,
  lng: 8.32
}];

/** Illustrative coastal shipping lanes (port to port, kept offshore). Not actual routes. */
export const SHIPPING = [['dakar', 'banjul'], ['banjul', 'bissau'], ['bissau', 'kamsar'], ['kamsar', 'conakry'], ['conakry', 'freetown'], ['freetown', 'monrovia'], ['monrovia', 'buchanan'], ['buchanan', 'sanpedro'], ['sanpedro', 'abidjan'], ['abidjan', 'takoradi'], ['takoradi', 'tema'], ['tema', 'lome'], ['lome', 'cotonou'], ['cotonou', 'lagos'], ['lagos', 'lekki'], ['lekki', 'onne'], ['onne', 'calabar']];
export const POPULAR = ['Gold', 'Oil & gas', 'Iron ore', 'Cocoa', 'Bauxite', 'Lithium'];

/** The view that frames the 12 ECOWAS members (Cabo Verde included) */
export const BOUNDS = [[-25.6, 3.9], [14.9, 17.4]];

/** The view that frames Nigeria (the Atlas opens here) */
export const NIGERIA_BOUNDS = [[2.6, 4.2], [14.7, 13.9]];

/** ECOWAS members since Burkina Faso, Mali and Niger left on 29 January 2025 */
export const ECOWAS = ['BJ', 'CV', 'CI', 'GM', 'GH', 'GN', 'GW', 'LR', 'NG', 'SN', 'SL', 'TG'];

/**
 * Where population labels sit (approximate centres; for placing labels only).
 * Countries use ISO2 codes; Nigerian states use the Data Hub's state slugs.
 */
export const COUNTRY_LABELS = {
  CV: [15.95, -23.95],
  SN: [14.4, -14.5],
  GM: [13.45, -15.4],
  GW: [12.0, -15.0],
  GN: [10.4, -10.9],
  SL: [8.6, -11.8],
  LR: [6.45, -9.4],
  CI: [7.6, -5.5],
  GH: [7.9, -1.0],
  TG: [8.6, 0.95],
  BJ: [9.6, 2.3],
  NG: [9.6, 8.1],
  ML: [14.6, -7.5],
  BF: [12.3, -1.6]
};
export const STATE_LABELS = {
  abia: [5.45, 7.52],
  adamawa: [9.33, 12.4],
  'akwa-ibom': [4.9, 7.85],
  anambra: [6.22, 6.95],
  bauchi: [10.6, 9.9],
  bayelsa: [4.75, 6.1],
  benue: [7.35, 8.75],
  borno: [11.9, 13.15],
  'cross-river': [5.85, 8.6],
  delta: [5.55, 6.0],
  ebonyi: [6.25, 8.05],
  edo: [6.6, 5.95],
  ekiti: [7.7, 5.3],
  enugu: [6.55, 7.4],
  abuja: [8.85, 7.2],
  gombe: [10.35, 11.2],
  imo: [5.55, 7.05],
  jigawa: [12.25, 9.55],
  kaduna: [10.4, 7.7],
  kano: [11.75, 8.5],
  katsina: [12.4, 7.55],
  kebbi: [11.55, 4.15],
  kogi: [7.75, 6.7],
  kwara: [8.85, 4.65],
  lagos: [6.55, 3.6],
  nasarawa: [8.55, 8.25],
  niger: [9.95, 5.6],
  ogun: [7.0, 3.4],
  ondo: [6.95, 5.0],
  osun: [7.55, 4.55],
  oyo: [8.15, 3.55],
  plateau: [9.2, 9.5],
  rivers: [4.85, 6.85],
  sokoto: [13.05, 5.35],
  taraba: [7.95, 10.75],
  yobe: [12.25, 11.45],
  zamfara: [12.1, 6.25]
};

/** Facility types: label and icon */
export const FACILITY_TYPES = {
  refinery: {
    label: 'Refinery',
    icon: 'fas fa-oil-can'
  },
  power_plant: {
    label: 'Power plant',
    icon: 'fas fa-bolt'
  },
  factory: {
    label: 'Factory',
    icon: 'fas fa-industry'
  },
  processing: {
    label: 'Processing plant',
    icon: 'fas fa-cogs'
  },
  other: {
    label: 'Other facility',
    icon: 'fas fa-building'
  }
};
export const STATUSES = {
  planned: 'Planned',
  construction: 'Under construction',
  operational: 'Operational',
  closed: 'Closed'
};